module.exports = __webpack_public_path__ + "static/media/ale_hero.fd39278f.png";